export default {"id":"ce234b41","attrs":{"viewBox":"0 0 512 512","width":"512","height":"512"}}